// MSAL for the portal's own registration, set up by createMsalApp in
// @higgins/utils (shared config, API scope, token getter, sign-out). Startup is
// startMsalApp and the header's account is useMsalAccount, both in @higgins/ui.
import { PublicClientApplication } from '@azure/msal-browser';
import { createMsalApp, onlineOnly } from '@higgins/utils';

const msalApp = createMsalApp((config) => new PublicClientApplication(config), {
  clientId: import.meta.env.VITE_AZURE_CLIENT_ID as string,
  tenantId: import.meta.env.VITE_AZURE_TENANT_ID as string,
});

export const { msalInstance, API_SCOPES, signOut } = msalApp;

/** Offline, never asks: the portal shows the tiles it last had instead of redirecting to sign-in (#391). */
export const getAccessToken = onlineOnly(msalApp.getAccessToken);
